/**
 * Reference for where all this stuff comes from:
 * https://gitlab.internal.granular.ag/core-accessibility/roles-svc/-/blob/master/roles_env/app_roles.yaml
 */

/**
 * On the left: what upstream calls these applications. On the right: a sane,
 * clean, 'nice' version of what we want to refer to it in the Core.
 *
 * This will serve as a single data-structure that keeps track of all the
 * application names and their nicknames in the Core. See
 * `models/applications.ts` for what we mean by that statement.
 */
export const RAW_TO_REFINED_APPLICATION_NAMES = {
  "activities-svc": "activities",
  "enrollments-svc": "enrollments",
  "fields-svc": "fields",
  "inputs-svc": "inputs",
  "roles-svc": "roles",
  financial_permission: "financials",
  nitrogen_permission: "nitrogen",
  landvisor: "landvisor",
} as const;
